/* Sana Silk — theme behaviour. No dependencies; pages work without it. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------------------------------------------------- drawers */
  var overlay = $('[data-ss-overlay]');
  var open = null;
  function drawer(el, show) {
    if (!el) return;
    if (open && open !== el) open.classList.remove('is-open');
    el.classList.toggle('is-open', show);
    if (overlay) overlay.classList.toggle('is-open', show);
    document.documentElement.style.overflow = show ? 'hidden' : '';
    open = show ? el : null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ss-open]');
    if (opener) { e.preventDefault(); drawer(document.getElementById(opener.getAttribute('data-ss-open')), true); return; }
    if (e.target.closest('[data-ss-close]') || e.target === overlay) drawer(open, false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) drawer(open, false); });

  /* ------------------------------------------------------ header shadow */
  var header = $('.ss-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ----------------------------------------------------- announcement */
  var notes = $$('.ss-announce__item');
  if (notes.length > 1) {
    var n = 0;
    setInterval(function () { notes[n].hidden = true; n = (n + 1) % notes.length; notes[n].hidden = false; }, 4500);
  }

  /* ------------------------------------------------------------- cart */
  var cartDrawer = document.getElementById('SsCart');
  function refreshCart(openAfter) {
    return fetch(root + '?sections=ss-cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      var html = new DOMParser().parseFromString(s['ss-cart-drawer'], 'text/html');
      var fresh = html.getElementById('SsCart');
      if (fresh && cartDrawer) cartDrawer.innerHTML = fresh.innerHTML;
      var count = html.querySelector('[data-ss-count]');
      $$('[data-ss-cart-count]').forEach(function (el) {
        var c = count ? parseInt(count.getAttribute('data-ss-count'), 10) : 0;
        el.textContent = c; el.hidden = !c;
      });
      if (openAfter) drawer(cartDrawer, true);
    });
  }
  window.SanaSilkCart = { refresh: refreshCart };

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ss-line]');
    if (!step) return;
    e.preventDefault();
    step.disabled = true;
    fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(step.getAttribute('data-ss-line'), 10), quantity: parseInt(step.getAttribute('data-ss-qty'), 10) })
    }).then(function () { return refreshCart(false); });
  });

  /* add to cart forms (product page, cards) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ss-add]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btns = $$('[type=submit]', form).concat($$('[data-ss-sticky-submit]'));
    btns.forEach(function (b) { b.disabled = true; });
    var err = $('[data-ss-error]', form); if (err) err.textContent = '';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCart(true); })
      .catch(function (j) { if (err) err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again.'; })
      .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
  });

  /* ----------------------------------------------- draggable slider */
  // Transform-driven slider: follows the finger/mouse 1:1, resists at the ends, and settles with
  // an ease-out on release (a quick flick moves one slide even when the drag was short).
  function Slider(viewport, onChange) {
    var track = viewport.firstElementChild;
    var slides = Array.prototype.slice.call(track.children);
    var self = { index: 0, count: slides.length };
    var startX = 0, startY = 0, dx = 0, t0 = 0, axis = null, down = false, moved = false;
    function width() { return viewport.clientWidth; }
    function place(x, animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    self.go = function (i, animate) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      self.index = i;
      place(-i * width(), animate);
      slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === i); sl.setAttribute('aria-hidden', k !== i); });
      var img = slides[i + 1] && slides[i + 1].querySelector('img[loading=lazy]');
      if (img) img.loading = 'eager';
      if (onChange) onChange(i);
    };
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; axis = null; dx = 0;
      startX = e.clientX; startY = e.clientY; t0 = Date.now();
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      var mx = e.clientX - startX, my = e.clientY - startY;
      if (!axis) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (axis === 'x') { viewport.setPointerCapture(e.pointerId); viewport.classList.add('is-dragging'); }
      }
      if (axis !== 'x') return;
      moved = true;
      dx = mx;
      var atEdge = (self.index === 0 && dx > 0) || (self.index === slides.length - 1 && dx < 0);
      place(-self.index * width() + (atEdge ? dx * 0.32 : dx), false);
    });
    function end() {
      if (!down) return;
      down = false;
      viewport.classList.remove('is-dragging');
      if (axis !== 'x') return;
      var v = dx / Math.max(1, Date.now() - t0);
      var next = self.index;
      if (dx < -width() * 0.16 || v < -0.4) next++;
      else if (dx > width() * 0.16 || v > 0.4) next--;
      self.go(next);
    }
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
    });
    window.addEventListener('resize', function () { self.go(self.index, false); });
    self.go(0, false);
    return self;
  }

  /* ------------------------------------------------------ PDP gallery */
  $$('[data-ss-gallery]').forEach(function (gal) {
    var viewport = $('[data-ss-viewport]', gal);
    var thumbs = $$('.ss-gal__thumb', gal);
    var counter = $('[data-ss-gal-i]', gal);
    var bar = $('[data-ss-gal-bar]', gal);
    var slider = Slider(viewport, function (i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (thumbs[i]) {
        var row = thumbs[i].parentNode;
        row.scrollTo({ left: thumbs[i].offsetLeft - row.clientWidth / 2 + thumbs[i].clientWidth / 2 });
      }
      if (counter) counter.textContent = i + 1;
      if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
    });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { slider.go(i); }); });
    $$('[data-ss-gal-prev]', gal).forEach(function (b) { b.addEventListener('click', function () { slider.go(slider.index - 1); }); });
    $$('[data-ss-gal-next]', gal).forEach(function (b) { b.addEventListener('click', function () { slider.go(slider.index + 1); }); });

    /* fullscreen viewer, built on first open */
    var lb = null, lbSlider = null;
    function openViewer(i) {
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'ss-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-label', 'Product images');
        var slidesHtml = $$('.ss-gal__slide', gal).map(function (sl) {
          var img = $('img', sl);
          return '<div class="ss-gal__slide"><img src="' + sl.getAttribute('data-full') + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" draggable="false" loading="lazy"></div>';
        }).join('');
        lb.innerHTML = '<div class="ss-lb__head"><span><span data-lb-i>1</span> / ' + thumbs.length + '</span>' +
          '<button class="ss-lb__close" type="button" aria-label="Close">' + $('.ss-gal__nav--prev', gal).innerHTML.replace('M15 5l-7 7 7 7', 'M6 6l12 12M18 6L6 18') + '</button></div>' +
          '<div class="ss-gal__viewport" tabindex="0"><div class="ss-gal__track">' + slidesHtml + '</div></div>' +
          '<button class="ss-gal__nav ss-gal__nav--prev" type="button" aria-label="Previous image">' + $('.ss-gal__nav--prev', gal).innerHTML + '</button>' +
          '<button class="ss-gal__nav ss-gal__nav--next" type="button" aria-label="Next image">' + $('.ss-gal__nav--next', gal).innerHTML + '</button>';
        document.body.appendChild(lb);
        var li = $('[data-lb-i]', lb);
        lbSlider = Slider($('.ss-gal__viewport', lb), function (k) { li.textContent = k + 1; slider.go(k); });
        $('.ss-lb__close', lb).addEventListener('click', closeViewer);
        $('.ss-gal__nav--prev', lb).addEventListener('click', function () { lbSlider.go(lbSlider.index - 1); });
        $('.ss-gal__nav--next', lb).addEventListener('click', function () { lbSlider.go(lbSlider.index + 1); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeViewer(); });
      }
      lbSlider.go(i, false);
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      $('.ss-gal__viewport', lb).focus();
    }
    function closeViewer() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; viewport.focus(); }
    viewport.addEventListener('click', function () { openViewer(slider.index); });
    $$('[data-ss-gal-zoom]', gal).forEach(function (b) { b.addEventListener('click', function () { openViewer(slider.index); }); });
  });

  /* ------------------------------------------------- PDP bundle tiers */
  function money(cents) {
    var fmt = (window.SanaSilk && SanaSilk.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var whole = v.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = whole + '.' + v.split('.')[1];
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt).replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
  }
  $$('[data-ss-buy]').forEach(function (buy) {
    var form = $('form[data-ss-add]', buy);
    var idInput = $('[name=id]', form);
    var qtyInput = $('[name=quantity]', form);
    var tiers = $$('.ss-tier', buy);
    var atcPrice = $$('[data-ss-atc-price]');
    var gifts = $$('[data-ss-gift-min]', buy);
    function pick(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); t.setAttribute('aria-checked', t === tier); });
      idInput.value = tier.getAttribute('data-variant');
      qtyInput.value = tier.getAttribute('data-qty');
      var price = parseInt(tier.getAttribute('data-price'), 10);
      var compare = parseInt(tier.getAttribute('data-compare'), 10);
      atcPrice.forEach(function (el) {
        el.innerHTML = (compare > price ? '<s>' + money(compare) + '</s> ' : '') + money(price);
      });
      var bottles = parseInt(tier.getAttribute('data-bottles'), 10) || 1;
      gifts.forEach(function (g) {
        var locked = bottles < parseInt(g.getAttribute('data-ss-gift-min'), 10);
        g.classList.toggle('is-locked', locked);
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', tier.getAttribute('data-variant'));
      if (tier.hasAttribute('data-tier')) url.searchParams.set('tier', tier.getAttribute('data-tier')); else url.searchParams.delete('tier');
      history.replaceState(null, '', url);
    }
    tiers.forEach(function (t) { t.addEventListener('click', function () { pick(t); }); });
    var want = new URLSearchParams(location.search).get('tier');
    var start = (want && $('.ss-tier[data-tier="' + want + '"]', buy)) || $('.ss-tier.is-active', buy) || tiers[0];
    if (start) pick(start);

    /* sticky add to cart once the main button scrolls away */
    var sticky = $('[data-ss-sticky]');
    var mainBtn = $('.ss-atc', buy);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { var on = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-visible', on); document.body.classList.toggle('has-sticky-atc', on && innerWidth < 990); });
      }).observe(mainBtn);
      $('[data-ss-sticky-submit]', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });

  /* ------------------------------------------------- horizontal scroller */
  $$('[data-ss-scroller]').forEach(function (wrap) {
    var sc = $('.ss-scroller', wrap);
    $$('[data-ss-dir]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { sc.scrollBy({ left: parseInt(b.getAttribute('data-ss-dir'), 10) * sc.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* ------------------------------------------------ image fade-in */
  $$(':is(.ss-gal__slide, .ss-card__img, .ss-split__media, .ss-ingredient, .ss-gallery-strip, .ss-why__media, .ss-gal__thumb) img').forEach(function (img) {
    function done() { img.classList.add('is-loaded'); }
    if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); }
  });

  /* --------------------------------------- drag-to-scroll rows (mouse) */
  $$('.ss-cards, .ss-scroller, .ss-gallery-strip, .ss-gal__thumbs').forEach(function (row) {
    var down = false, x0 = 0, s0 = 0, moved = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || row.scrollWidth <= row.clientWidth) return;
      down = true; moved = false; x0 = e.clientX; s0 = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - x0;
      if (!moved && Math.abs(d) > 5) { moved = true; row.classList.add('ss-drag', 'is-dragging'); }
      if (moved) row.scrollLeft = s0 - d;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) setTimeout(function () { row.classList.remove('is-dragging'); }, 0);
    });
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ------------------------------------------------------------ reveal */
  var reveal = $$('.ss-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveal.forEach(function (el) { io.observe(el); });
  } else reveal.forEach(function (el) { el.classList.add('is-in'); });
  /* ------------------------------------------- 3D bottle (lazy module) */
  $$('[data-ss-3d]').forEach(function (root) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      // a module script tag, not import(): Shopify's asset minifier rewrites import() into require()
      var go = function () { if (window.SanaSilkMount3D) window.SanaSilkMount3D(root); };
      if (window.SanaSilkMount3D) return go();
      var tag = document.createElement('script');
      tag.type = 'module';
      tag.src = root.getAttribute('data-src');
      tag.onload = go;
      tag.onerror = function () { console.warn('3D bottle unavailable'); };
      document.head.appendChild(tag);
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  });

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------- videos: load + play on screen */
  var vids = $$('[data-ss-video]');
  // Videos wait until the page has loaded (and the hero photo has painted), so they never compete
  // with the first view on a phone connection; they fade in over their poster photo.
  function startVideos() {
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && v.offsetParent !== null && !reduce) {
          if (!v.src) {
            v.src = v.getAttribute('data-src');
            v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
          }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.src) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { vio.observe(v); });
  }
  }
  var later = function () { setTimeout(startVideos, 1200); };
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });

  /* ------------------------------------- headings: word-by-word reveal */
  if (!reduce) {
    $$('[data-ss-words], .ss-h2:not([data-ss-nowords])').forEach(function (h) {
      var i = 0;
      (function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var o = document.createElement('span'); o.className = 'ss-w';
              var inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--i', i++);
              o.appendChild(inner); frag.appendChild(o);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1 && !c.classList.contains('ss-w')) wrap(c);
        });
      })(h);
    });
    if ('IntersectionObserver' in window) {
      var wio = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-words-in'); wio.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      $$('[data-ss-words], .ss-h2').forEach(function (h) { wio.observe(h); });
    } else $$('[data-ss-words], .ss-h2').forEach(function (h) { h.classList.add('is-words-in'); });
  }

  /* ------------------------------------------------ parallax drift */
  var drift = $$('[data-ss-parallax]');
  if (drift.length && !reduce) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight;
      drift.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-ss-parallax')) || 0.1;
        var room = el.offsetHeight * 0.085;   // never drift past the extra image height (no gaps)
        var off = Math.max(-room, Math.min(room, (r.top + r.height / 2 - vh / 2) * -k));
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ------------------------------------------- 3D tilt on cards */
  if (!reduce && matchMedia('(hover: hover)').matches) {
    $$('.ss-card').forEach(function (card) {
      var img = $('.ss-card__img', card);
      if (!img) return;
      card.addEventListener('pointermove', function (e) {
        var r = img.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.classList.add('is-tilting');
        img.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 7).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 9).toFixed(2) + 'deg) translateZ(0)';
        img.style.setProperty('--gx', (x * 100).toFixed(0) + '%');
        img.style.setProperty('--gy', (y * 100).toFixed(0) + '%');
      });
      card.addEventListener('pointerleave', function () { card.classList.remove('is-tilting'); img.style.transform = ''; });
    });
  }

  window.SanaSilkReady = true;
})();
